import { ProductSpecCode, ProductSpecs } from '../types/productSchema';

export const extraAttributes: Array<Pick<ProductSpecs, 'code' | 'title'>> = [
  {
    code: ProductSpecCode.Size,
    title: 'Типоразмер',
  },
  {
    code: ProductSpecCode.Brand,
    title: 'Бренд',
  },
  {
    code: ProductSpecCode.Model,
    title: 'Модель',
  },
  {
    code: ProductSpecCode.ExtendedWarranty,
    title: 'Расширенная гарантия',
  },
  {
    code: ProductSpecCode.StandardFactory,
    title: 'Стандартная заводская',
  },
  {
    code: ProductSpecCode.BackProduct,
    title: 'Возврат',
  },
  {
    code: ProductSpecCode.SellerCode,
    title: 'Код',
  },
];
